import React from "react";
import { FaLock } from "react-icons/fa";
import "./SupportHandbookAccessForm.css";

const SupportHandbookAccessForm = ({
  code,
  handleChange,
  handleSubmit,
  error,
}) => {
  return (
    <form onSubmit={handleSubmit} className="_hAForm_q1A_">
      <div className="_lIWrap_r2B_">
        <FaLock className="_lIcon_s3C_" />
      </div>
      <h2 className="_fTitle_t4D_">Support Handbook Access</h2>
      <p className="_fDesc_u5D_">
        This page is restricted.
        <br />
        Please enter the access code.
      </p>
      <input
        type="password"
        placeholder="Enter code"
        value={code}
        onChange={handleChange}
        className="_aInput_v6D_"
      />
      <button type="submit" className=" _cTAButton_c6F_ _devotee_d7G_ ">
        Enter
      </button>
      {error && <div className="_eMsg_x8D_">{error}</div>}
    </form>
  );
};

export default SupportHandbookAccessForm;
